import { render, staticRenderFns } from "./HistoriqueChangement.vue?vue&type=template&id=32195a64"
import script from "./HistoriqueChangement.vue?vue&type=script&lang=js"
export * from "./HistoriqueChangement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports